import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/api";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Loader2, KeyRound } from "lucide-react";

const SCOPES = {
  marketplace: { url: "/marketplace/perms", title: "Autorisations Marketplace", help: "Vous (dirigeant) achetez et gérez les licences. Ouvrez ou non la consultation et l'achat à vos responsables d'établissement et à vos salariés.",
    actions: { consulter: "Consulter le catalogue", acheter: "Acheter (engage l'entreprise)" } },
  billetterie: { url: "/billetterie/perms", title: "Autorisations Billetterie", help: "Qui peut consulter les billets des parcs partenaires, acheter (pour l'établissement ou pour soi) et attribuer les billets aux salariés.",
    actions: { consulter: "Consulter le catalogue", acheter: "Acheter des billets", attribuer: "Attribuer les billets (établissement)" } },
};
const ROLES = { responsable: "Responsable d'établissement", salarie: "Salarié" };

/** Dirigeant → droits des responsables d'établissement et salariés sur la Marketplace ou la Billetterie. */
export function AccessPermsPanel({ scope }) {
  const cfg = SCOPES[scope];
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState("");
  useEffect(() => { api.get(cfg.url).then((r) => setData(r.data)).catch(() => setData({ perms: {}, defaults: {} })); }, [cfg.url]);
  const toggle = async (role, action, value) => {
    setBusy(`${role}-${action}`);
    try { const { data: d } = await api.put(cfg.url, { [role]: { ...data.perms[role], [action]: value } }); setData(d); toast.success("Autorisations enregistrées"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setBusy(""); }
  };
  if (!data) return <div className="text-sm text-[#868E96] p-4"><Loader2 className="h-4 w-4 animate-spin inline mr-2" />Chargement…</div>;
  return (
    <div className="bg-white border border-[#DEE2E6] p-5" data-testid={`perms-${scope}`}>
      <h3 className="font-display font-black text-lg flex items-center gap-2"><KeyRound className="h-4 w-4" />{cfg.title}</h3>
      <p className="text-xs text-[#495057] mt-1">{cfg.help}</p>
      <div className="mt-4 grid md:grid-cols-2 gap-4">
        {Object.entries(ROLES).map(([role, rl]) => (
          <div key={role} className="border border-[#DEE2E6] p-4" data-testid={`perms-${scope}-${role}`}>
            <div className="font-bold text-sm mb-3">{rl}</div>
            <div className="space-y-2">
              {Object.entries(cfg.actions).filter(([a]) => role === "responsable" || a !== "attribuer").map(([a, label]) => (
                <label key={a} className="flex items-center justify-between gap-3 text-sm"><span>{label}</span><Switch checked={!!data.perms?.[role]?.[a]} disabled={busy === `${role}-${a}`} onCheckedChange={(v) => toggle(role, a, v)} data-testid={`perms-${scope}-${role}-${a}`} /></label>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
